/**
 * Responsive Layout Component JavaScript
 * 处理响应式布局组件的动态状态和交互
 */

class ResponsiveLayoutComponent {
  constructor() {
    this.currentLayout = this.getCurrentLayout();
    this.init();
  }

  init() {
    // 监听窗口大小变化
    this.initResizeListener();
  }

  /**
   * 获取当前布局类型
   */
  getCurrentLayout() {
    const width = window.innerWidth;
    if (width <= 734) {
      return 'mobile';
    } else if (width <= 1068) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  /**
   * 初始化窗口大小变化监听
   */
  initResizeListener() {
    let resizeTimeout = null;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleLayoutChange();
      }, 150);
    });
  }

  /**
   * 处理布局变化
   */
  handleLayoutChange() {
    const newLayout = this.getCurrentLayout();
    
    if (newLayout !== this.currentLayout) {
      // 触发布局变化事件
      const event = new CustomEvent('responsiveLayoutChange', {
        detail: {
          newLayout: newLayout,
          oldLayout: this.currentLayout,
          width: window.innerWidth,
          timestamp: Date.now()
        }
      });
      window.dispatchEvent(event);
      
      // 更新当前布局
      this.currentLayout = newLayout;
    }
  }

  /**
   * 公共方法：手动触发布局检测
   */
  triggerLayoutCheck() {
    this.handleLayoutChange();
  }

  /**
   * 公共方法：判断是否为手机布局
   */
  isMobile() {
    return this.currentLayout === 'mobile';
  }

  /**
   * 公共方法：判断是否为平板布局
   */
  isTablet() {
    return this.currentLayout === 'tablet';
  }

  /**
   * 公共方法：判断是否为桌面布局
   */
  isDesktop() {
    return this.currentLayout === 'desktop';
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  window.ResponsiveLayoutComponent = new ResponsiveLayoutComponent();
});

// 导出类，供外部使用
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ResponsiveLayoutComponent;
}

// 全局便捷函数
window.getResponsiveLayout = function() {
  return window.ResponsiveLayoutComponent ? window.ResponsiveLayoutComponent.currentLayout : null;
};

window.isResponsiveMobile = function() {
  return window.ResponsiveLayoutComponent ? window.ResponsiveLayoutComponent.isMobile() : false;
};

window.isResponsiveTablet = function() {
  return window.ResponsiveLayoutComponent ? window.ResponsiveLayoutComponent.isTablet() : false;
};

window.isResponsiveDesktop = function() {
  return window.ResponsiveLayoutComponent ? window.ResponsiveLayoutComponent.isDesktop() : false;
};

